import styled from 'styled-components';
import { Collapse as MuiCollapse, TableCell } from '@mui/material';

export const Container = styled.div`
  width: 100%;
  padding: 10px;
`;

export const TableRowsContainer = styled.div`
  display: contents;
`;

export const Collapse = styled(MuiCollapse)`
  width: auto;
`;

export const Cell = styled(TableCell)`
  padding: 5px !important;
`;
